import useBackend from '@/backend';
import { useModalStoreActions, useNotificationsStoreActions } from '@/store';
import Notification_Toast_Primary from '@/components/Notifications/Notification_Toast_Primary/Notification_Toast_Primary';
import { useState } from 'react';
import useGetRewards from '../claims/useGetRewards/useGetRewards';

export interface DepositReward {
	id: string;
	title: string;
	description: string;
	status: string;
	endDate: string;
}

/* --------------------------------- OPTIONS -------------------------------- */

interface Body {
	bonusId: string | null;
}

/* -------------------------------------------------------------------------- */

const route = `/bonus/forfeit`;

const headers: HeadersInit = {
	'Content-Type': 'application/json',
};
const body: Body = {
	bonusId: null,
};

/* -------------------------------------------------------------------------- */

const useForfeitReward = () => {
	const { addNotification } = useNotificationsStoreActions();
	const { setModalStatus } = useModalStoreActions();
	const { getUnclaimedBonuses } = useGetRewards();

	const [data, setData] = useState<DepositReward | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<Error | null>(null);
	const { url_V3, getAccessToken } = useBackend();

	const forfeitReward = async (
		bonusId: string
	): Promise<DepositReward | null> => {
		setLoading(true);
		setError(null);

		/* -------------------------------------------------------------------------- */
		const token = await getAccessToken({ v: 3 });
		if (token) headers.Authorization = token;
		body.bonusId = bonusId;

		/* -------------------------------------------------------------------------- */

		try {
			const response = await fetch(`${url_V3}${route}`, {
				method: 'POST',
				headers,
				body: JSON.stringify(body),
			});

			const data = await response.json();

			if (data.success) {
				getUnclaimedBonuses();
				setData(data?.data?.bonus);
				setModalStatus(null);
				addNotification(({ id }) => (
					<Notification_Toast_Primary id={id}>
						<div className="flex flex-col">
							<p className="font-bold">Reward forfeited successfully</p>
						</div>
					</Notification_Toast_Primary>
				));

				return data?.data?.bonus;
			} else {
				throw new Error(data.message || 'Failed to fetch reward');
			}
		} catch (err) {
			setError(err as Error);
			return null;
		} finally {
			setLoading(false);
		}
	};

	return {
		forfeitReward,
		data,
		loading,
		error,
	};
};

export default useForfeitReward;
